import _ from 'lodash'
import * as mpActions from './components/actions'
import { filterItems } from './ListView'

export function reducer(state, { type, payload }) {
  switch (type) {
    case actions.GET_LIST:
      return {
        ...state,
        loading: true,
        listId: payload
      }
    case actions.REMOVE_VALIDATION_FILTER:
      return {
        ...state,
        validationFilter: false
      }
    case actions.GET_LIST_DONE:
      return getListDone(state, payload)
    case actions.GET_LISTITEMS_DONE:
      return getListItemsDone(state, payload)
    case actions.UPDATE_FIELD:
      if (payload.id === 'new') {
        const data = { ...state.newItem.data }
        _.set(data, payload.field.name, payload.value)
        return {
          ...state,
          newItem: {
            ...state.newItem,
            data
          }
        }
      } else {
        return {
          ...state,
          items: state.items.map(i => {
            if (i.id === payload.id) {
              if(payload.field.name === 'formatted.emails'){
                _.set(i, payload.field.name, payload.value)
              }
              const data = { ...i.data }
              _.set(data, payload.field.name, payload.value)
              return {
                ...i,
                data
              }
            } else {
              return i
            }
          })
        }
      }
    case actions.ADD_ITEM_DONE:
      return {
        ...state,
        items: [payload, ...state.items],
        newItem: { id: 'new', data: {} },
        noItems: state.noItems + 1
      }
    case actions.REMOVE_ITEM_DONE:
      const s = {
        ...state,
        items: state.items.filter(i => i.id !== payload),
        noItems: state.noItems - 1
      }
      return s
    case actions.GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload
      }
    case actions.TOGGLE_CHECKED:
      const relevantItems = filterItems(state).map(i => i.id)
      return {
        ...state,
        items: state.items.map(i => {
          return (relevantItems.includes(i.id) && (state.gridFilteredIds ? state.gridFilteredIds.includes(i.id) : true))
            ? {
                ...i,
                data: { ...i.data, checked: payload }
              }
            : i
        })
      }
      case actions.GRID_FILTER_APPLIED:
      return {
        ...state,
        gridFilteredIds: payload
        }
    case actions.ADD_COLUMN:
      return {
        ...state,
        _fields: [...state._fields, payload],
        fields: [...preFields, ...state._fields, payload, ...postFields]
      }
    case actions.REMOVE_COLUMN:
      return {
        ...state,
        _fields: [...state._fields].filter(field => field.name !== payload),
        fields: [...preFields, ...state._fields, ...postFields].filter(
          field => field.name !== payload
        )
      }
    case actions.SELECT_ACTION:
      const items = state.items.find(i => i.data?.checked)
        ? state.items
        : state.items.map(i => ({
            ...i,
            data: { ...i.data, checked: true }
          }))
      // payload is the name of the action

      const defaultStage = mpActions[payload].loadStage

      return {
        ...state,
        items,
        validationFilter: Boolean(payload), // If there is an action set up validation
        // If loadStage is provided, it will start by loading from that stage number, else start from stages[0]
        massAction: { name: payload, stage: 0 }
      }
    case actions.SET_FILTER:
      return {
        ...state,
        filter: payload
      }
    case actions.FILTER_STATUSES:
      return {
        ...state,
        filterStatus: payload
      }
    case actions.FILTER_VALIDS:
      return {
        ...state,
        filterValid: payload
      }
    case actions.GET_EMPLOYEE:
      return {
        ...state,
        employee: payload
      }
    case actions.GET_ALL_EMPLOYEES:
      return {
        ...state,
        allEmployees: payload
      }
    case actions.ADD_EMPLOYEE:
      return {
        ...state,
        list: { ...state.list, sharedWith: [...state.list.sharedWith, payload] }
      }
    case actions.REMOVE_EMPLOYEE:
      return {
        ...state,
        list: {
          ...state.list,
          sharedWith: state.list.sharedWith.filter(
            employee => employee.userId !== payload
          )
        }
      }
    case actions.NEXT_STAGE:
      return {
        ...state,
        items: state.items.map(i => {
          return {
            ...i,
            data: {
              ...i.data,
              checked: (payload?.uncheck || []).includes(i.id)
                ? false
                : i.data.checked
            }
          }
        }),
        massAction: {
          ...state.massAction,
          stage: state.massAction.stage + 1
        }
      }
    case actions.PREV_STAGE:
      return {
        ...state,
        massAction: {
          ...state.massAction,
          stage: state.massAction.stage - 1
        }
      }
    case actions.FEEDBACK:
      return {
        ...state,
        feedback: payload
      }
    case actions.FEEDBACK_HIDE:
      return {
        ...state,
        feedback: null
      }

    case actions.END_ACTION:
      return {
        ...state,
        massAction: { name: '', stage: null },
        ignoreRuleError: { name: '', message: '' }
      }
    case actions.IGNORE_RULE:
      return {
        ...state,
        ignoreRule: payload,
        ignoreRuleReason: ''
      }
    case actions.IGNORE_RULE_REASON:
      return {
        ...state,
        ignoreRuleReason: payload,
        ignoreRuleError: { name: '', message: '' }
      }
    case actions.IGNORE_RULE_DONE:
      return {
        ...state,
        items: state.items.map(i => {
          if (i.id !== state.ignoreRule) return i
          i.data.sherlock.allowed = true
          i.data.sherlock.failed = false
          i.data.sherlock.ignored = true
          return i
        }),
        ignoreRule: null,
        ignoreRuleReason: ''
      }
    case actions.IGNORE_RULE_CANCEL:
      return {
        ...state,
        ignoreRule: null,
        ignoreRuleReason: ''
      }
    case actions.UPDATE_IGNORE_LIST:
      return {
        ...state,
        items: state.items.map(i => {
          if (i.id === payload.id) {
            return {
              ...i,
              data: { ...i.data, checked: payload.value }
            }
          } else {
            return i
          }
        })
      }
    case actions.IGNORE_RULE_ERROR:
      return {
        ...state,
        ignoreRuleError: {
          name: payload.name,
          message: payload.message
        }
      }
    case actions.ITEM_SYNC:
      const ourItem = Boolean(
        _.find(state.items, i => i.id === payload.item.id)
      )

      if (!ourItem) return state
      return {
        ...state,
        ...(((payload.field !== 'data.sherlock' && payload.field !== 'data.status' && payload.field !== 'data') || (!state.surveyUUIDRecieved && payload.item.data.surveyUUID)) && {
          fields: getFields(state, payload.item.data.surveyUUID),
          surveyUUIDRecieved: true,
        }),
        syncItem: payload,
        items: state.items
          .map(i => {
            // update item if it has same ID and it is either forced sync or
            // update was done by some other user and is newer than data we have
            if (i.id === payload.item?.id) {
              if (payload.field) {
                const _item = i
                if(payload.item.data.surveyUUID){
                  _.set(_item, 'surveyUUID', payload.item.data.surveyUUID)
                }
                _.set(_item, payload.field, _.get(payload.item, payload.field))
                _.set(_item, 'formatted', payload.item.formatted)
                return _item
              } else {
                return payload.item
              }
            } else {
              return i
            }
          })
          .filter(i => i.listId === state.list.id)
      }
    case actions.SORT_BY:
      function compare(a, b) {
        const valueA = JSON.stringify(_.get(a.data, payload.name, ''))
          .toUpperCase()
          .replace(/[^A-Z0-9]/g, '')
        const valueB = JSON.stringify(_.get(b.data, payload.name, ''))
          .toUpperCase()
          .replace(/[^A-Z0-9]/g, '')

        return valueA > valueB === payload.az ? 1 : -1 // eslint-disable-line
      }

      return {
        ...state,
        items: state.items.sort(compare),
        sortBy: payload
      }
    case actions.SET_EDIT_COLUMN:
      return { ...state, editColumn: payload }
    case actions.FILTER_VALID_EXPERTS:
      return {
        ...state,
        filterValid: 'INVALID'
      }
    case actions.REMOVE_FILTER_ACTIVE_EXPERTS:
      return {
        ...state,
        isFiltered: false,
        items: state.stashedItems,
        stashedItems: []
      }
    case actions.BULK_CHECK:
      const newState = {
        ...state,
        items: state.items.map(i => ({
          ...i,
          data: {
            ...i.data,
            checked: payload.includes(i.id)
          }
        }))
      }
      return newState
    case actions.CREATE_MASS_ACTION_DONE:
      return {
        ...state,
        massAction: {
          ...state.massAction,
          id: payload
        },
        items: state.items.map(i => {
          return i.data.checked
            ? {
                ...i,
                data: {
                  ...i.data,
                  status: {
                    status: 'QUEUED',
                    description: 'queued',
                    timestamp: Date.now(),
                    isError: false
                  }
                }
              }
            : i
        })
      }
    case actions.CREATE_MULTIPLE_MASS_ACTION_DONE:
      return {
        ...state,
        massActions: payload,
        items: state.items.map(i => {
          return i.data.checked
            ? {
                ...i,
                data: {
                  ...i.data,
                  status: {
                    status: 'QUEUED',
                    description: 'queued',
                    timestamp: Date.now(),
                    isError: false
                  }
                }
              }
            : i
        })
      }
    case actions.UPDATE_ITEM_EMAIL:
      const updatedItems = state.items.map(item => {
        if (item.id !== payload.currentItem.id) {
          return item
        }
        return { ...item, data: { ...item.data, emails: payload.value } }
      })
      return { ...state, items: updatedItems }
    case actions.UPDATE_SURVEY_COLUMN:
      console.debug(state.fields)
      return {
        ...state,
        fields: [
          ...state.fields.slice(0, -1),
          {
            name: 'surveyUUID',
            type: 'input',
            title: 'Survey UUID',
            width: 250
          },
          state.fields.slice(-1)[0]
        ]
      }
    case actions.SET_RULE_IGNORE_SENDNIG:
      return { ...state, ruleIgnoreSending: payload }
    case actions.SET_EXPERTS_LOADED:
      return { ...state, expertsLoaded: true }
    case actions.SET_NO_ITEMS:
      return { ...state, noItems: payload, noItemsSet: true }
    case actions.DOWNLOAD_STARTED:
      return { ...state, downloadInProgress: true }
    case actions.DOWNLOAD_COMPLETED:
      return { ...state, downloadInProgress: false }
    case actions.ADD_TO_PROJECT:
      const item = state.items.find(item => item.id === payload.itemId)
      if (!item) return state
      return {
        ...state,
        items: state.items.map(i => {
          i.data.checked = i.id === payload.itemId
          return i
        }),

        massAction: {
          name: 'addToProject',
          stage: 0
        }
      }
    default:
      return state
  }
}

export const initialState = {
  loading: true,
  loadingSherlockRule: false,
  validationFilter: false,
  listId: null,
  massAction: { name: '' },
  massActions: [],
  fields: [],
  filter: '',
  _fields: [],
  syncItem: {},
  gridFilteredIds: null,
  surveyUUIDRecieved: false,
  items: [],
  newItem: { id: 'new', data: {} },
  employee: {},
  allEmployees: [],
  involvedEmployees: [],
  feedback: null,
  ignoreRule: null,
  ignoreRuleReason: '',
  ignoreRuleError: { name: '', message: '' },
  sortBy: { name: '', az: true },
  editColumn: false,
  isFiltered: false,
  stashedItems: [],
  filterStatus: 'ALL',
  filterValid: 'ALL',
  noItems: 0,
  noItemsSet: false,
  expertsLoaded: false,
  downloadInProgress: false
}

const preFields = [
  {
    title: '',
    name: 'checked',
    type: 'checkbox',
    local: true,
    width: 40
  },
  {
    title: '',
    name: 'validation',
    type: 'validation',
    local: true,
    width: 50
  }
]

const postFields = [
  {
    title: 'Actions',
    name: 'actions',
    type: 'actions',
    local: true,
    width: 100
  }
]

function getFields(state, shouldShowSurveyUUID) {
  const allFields = [...preFields, ...state._fields, ...postFields]
  return shouldShowSurveyUUID || state.items.find(i => i.data.surveyUUID)
    ? allFields
    : [...allFields].filter(field => field.name !== 'surveyUUID')
}

function getListItemsDone(state, payload) {
  const shouldShow = Boolean(payload?.listItems?.find(i => i.data.surveyUUID))
  const loading =
    payload.listItems.length + state.items.length !== payload.count
  return {
    ...state,
    loadingItems: loading,
    ...(!loading && {
      fields: getFields(state, shouldShow)
    }),
    list: {
      ...state.list,
      listItems: [...state.list.listItems, ...payload.listItems]
    },
    items: [
      ...state.items,
      ...payload.listItems.map(i => {
        _.set(
          i,
          'data.checked',
          state.massAction?.active &&
            state.massAction?.id === _.last(i.actions)?.massActionId
        )
        return i
      })
    ]
  }
}

function getListDone(state, payload) {
  const massAction = payload.massActions.filter(a => a.active)[0]
  const shouldShow = Boolean(payload.listItems?.find(i => i.data.surveyUUID))
  const allFields = [...preFields, ...payload.fields, ...postFields]

  return {
    ...state,
    loading: false,
    name: payload.name,
    fields: shouldShow
      ? allFields
      : [...allFields].filter(field => field.name !== 'surveyUUID'),
    _fields: payload.fields,
    list: {
      ...payload,
      listItems: [],
      from: JSON.parse(window.localStorage.getItem('ngStorage-user')).email,
      cc: [],
      bcc: []
    },
    // To return to the previous mass action's stage
    massAction: massAction?.active
      ? {
          name: massAction?.type,
          stage: mpActions[massAction.type].loadStage,
          id: massAction.id
        }
      : { name: '' },
    items: []
  }
}

export const actions = {
  GET_LIST: 'mp_list_view-get_list',
  GET_LIST_DONE: 'mp_list_view-get_list_done',
  GET_LISTITEMS_DONE: 'mp_list_view-get_listitems_done',
  GET_LIST_ERROR: 'mp_list_view-get_list_error',
  UPDATE_FIELD: 'mp_list_view-update_field',
  ADD_ITEM: 'mp_list_view-add_item',
  ADD_ITEM_DONE: 'mp_list_view-add_item_done',
  REMOVE_ITEM_DONE: 'mp_list_view-remove_item_done',
  TOGGLE_CHECKED: 'mp_list_view-toggle_checked',
  GRID_FILTER_APPLIED: 'mp_list_grid_filter_applied',
  ADD_COLUMN: 'mp_list_view-add_column',
  REMOVE_COLUMN: 'mp_list_view-remove_column',
  SELECT_ACTION: 'mp_list_select_action',
  SET_FILTER: 'mp_list-set_filter',
  REMOVE_VALIDATION_FILTER: 'mp_list-remove_validation_filter',
  GET_EMPLOYEE: 'mp_list_view-get_employee',
  GET_ALL_EMPLOYEES: 'mp_list-get_all_employees',
  NEXT_STAGE: 'mp_list-next_stage',
  PREV_STAGE: 'mp_list-prev_stage',
  ADD_EMPLOYEE: 'mp-list-add_employee',
  REMOVE_EMPLOYEE: 'mp-list-remove_employee',
  FEEDBACK: 'mp-list-show-feedback',
  FEEDBACK_HIDE: 'mp-list-hide-feedback',
  IGNORE_RULE: 'mp-list-ignore-rule',
  IGNORE_RULE_REASON: 'mp-list-ignore-reason',
  IGNORE_RULE_DONE: 'mp-list-ignore-done',
  END_ACTION: 'mp-list-end-action',
  IGNORE_RULE_CANCEL: 'mp-list-ignore-rule-cancel',
  UPDATE_IGNORE_LIST: 'mp-list-ignore-update',
  IGNORE_RULE_ERROR: 'mp-list-ignore-error',
  ITEM_SYNC: 'mp-list-item-sync',
  SORT_BY: 'mp-sort-list-items',
  SET_EDIT_COLUMN: 'mp-edit-column-name',
  FILTER_VALID_EXPERTS: 'mp_filter_valid_experts',
  REMOVE_FILTER_ACTIVE_EXPERTS: 'mp_remove_filter_valid_experts',
  CREATE_MASS_ACTION_DONE: 'mp_create_mass_action_done',
  CREATE_MULTIPLE_MASS_ACTION_DONE: 'mp_create_multiple_mass_actions_done',
  FILTER_VALIDS: 'mp_filter_valids',
  UPDATE_ITEM_EMAIL: 'mp_update_item_email',
  SET_RULE_IGNORE_SENDNIG: 'mp_set_rule_ignore_sending',
  FILTER_STATUSES: 'mp_filter_statuses',
  UPDATE_SURVEY_COLUMN: 'mp_update_survey_column',
  SET_NO_ITEMS: 'mp_set_number_of_items',
  SET_EXPERTS_LOADED: 'mp_set_experts_loaded',
  BULK_CHECK: 'mp_bulk_check',
  DOWNLOAD_STARTED: 'mp_download_started',
  DOWNLOAD_COMPLETED: 'mp_download_completed',
  ADD_TO_PROJECT: 'mp_add_to_project'
}
